<template>
    <div id="app"
         v-loading.fullscreen.lock="$root.loading"
         element-loading-text="Loading..."
         element-loading-spinner="el-icon-loading"
         element-loading-background="rgba(0, 0, 0, 0.1)">

        <router-view/>

    </div>
</template>

<script type="text/babel">

    export default {
        name: 'App',
        data() {
            return{

            }
        },
        components: {

        },
        mounted(){

        }
    }
</script>

<style lang="scss">
@import './assets/entry.scss';
html,body{
    position: relative;
}
/*html {
    height: 100%;
    overflow: hidden;
}
body {
    height: 100%;
    overflow: scroll;
}*/
body,h1,h2,h3,h4,h5,p {
    margin: 0;
}
/*html ,body {
    height: 100%;
}*/
ul,ol {
    margin: 0;
    padding: 0;
    list-style: none;
}
#app {
  font-family: $--font-family;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: $--text-color;
    min-height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/App.vue